import { Link } from 'react-router-dom';
import { useTenant } from '../context/TenantContext';
import { SUPPORT_EMAIL } from '../config/support';

export default function SuspendedClub() {
  const { club, error } = useTenant();

  const isCancelled = error === 'CLUB_CANCELLED';
  const name        = club?.name || 'This club';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-4">
        <div className="text-6xl">{isCancelled ? '🔒' : '⚠️'}</div>
        <h1 className="text-2xl font-bold text-gray-900">
          {isCancelled ? 'Account Cancelled' : 'Account Suspended'}
        </h1>
        <p className="text-gray-600">
          {isCancelled
            ? `${name}'s TrainAxis account has been cancelled.`
            : `${name}'s TrainAxis account has been temporarily suspended.`}
        </p>
        {!isCancelled && (
          <p className="text-sm text-gray-500">
            Please contact your club administrator or TrainAxis support to resolve this. If
            you're the admin and have already paid, log in to submit your payment proof.
          </p>
        )}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {!isCancelled && (
            <Link
              to="/login"
              className="inline-block px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-semibold"
            >
              Admin Log In
            </Link>
          )}
          <a
            href="https://wa.me/61414934174"
            target="_blank"
            rel="noreferrer"
            className={`inline-block px-6 py-2 rounded-lg transition-colors text-sm font-semibold ${isCancelled ? 'bg-primary text-white hover:bg-primary-dark' : 'border border-divider text-secondary hover:bg-nav-hover'}`}
          >
            WhatsApp Us
          </a>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="inline-block px-6 py-2 border border-divider text-secondary rounded-lg hover:bg-nav-hover transition-colors text-sm font-semibold"
          >
            Email Support
          </a>
        </div>
      </div>
    </div>
  );
}
